'use client';

import React from 'react';
import { useParticipants } from '@livekit/components-react';
import { Users } from 'lucide-react';

interface ParticipantsButtonProps {
  onClick: () => void;
  isPressed?: boolean;
}

export function ParticipantsButton({ onClick, isPressed = false }: ParticipantsButtonProps) {
  const participants = useParticipants();

  return (
    <button
      onClick={onClick}
      className="lk-button lk-participants-toggle"
      aria-label={`Participantes (${participants.length})`}
      aria-pressed={isPressed}
      data-tooltip="Participantes"
    >
      <Users className="w-5 h-5" />
    </button>
  );
}
